import React from "react";
import "../styles/howToUse.scss";
import ProfileLayout from "../component/reusable/ProfileLayout";
import { studentSidebarLinks } from "../profileSidebarLinks";
import { useNavigate } from "react-router-dom";
import GptLayout from "../component/gptLayout";

const HowToUse = () => {
  const navigate = useNavigate()

  const redirectOnPage = (link) => {
    if (link) {
      navigate(link)
    }
  }

  return (
    <GptLayout>
      <ProfileLayout sidebarLinks={studentSidebarLinks}>
        <section className="howTOUse_main txt_color">
          <h1 className="page_heading">How to Use NDA-GPT?</h1>
          <div className="subHeading">Welcome to NDA-GPT</div>
          <div className="content">
            <p>
              Your trusted AI-powered mentor for excelling in the <b>National Defence Academy (NDA)</b> entrance exam and preparing early for the <b>SSB Interview</b>.
            </p>
            <br />
            <p>
              NDA-GPT goes beyond traditional test prep—it’s an <b>interactive, smart learning platform</b> that combines the precision of <b>advanced AI</b> with the insights of <b>seasoned educators and defense professionals</b>.
            </p>
            <br />
            <p>
              Whether you're revising core subjects, sharpening your physical and communication skills, or getting familiar with SSB procedures in advance,<b> NDA-GPT provides personalized guidance, NDA-level practice tests, and accurate performance feedback</b> -all in one place.
            </p>
            <br />
            <p>
            With NDA-GPT by your side, you're not just preparing for an exam—you’re preparing to lead.
            </p>
          </div>

          <div className="feature_btns">
            <div className="heading">
              <b>Features</b> ( How to use them)
            </div>
            <div className="btn_grp">
              <div className="btn">
                <button onClick={() => redirectOnPage("/how-use-nda-mentor-classroom")}>NDA Mentor</button>
              </div>
              <div className="btn">
                <button onClick={() => redirectOnPage("/how-use-physical-classroom")}>Physical</button>
              </div>
              <div className="btn">
                <button onClick={() => redirectOnPage("/how-use-medical-classroom")}>Medical</button>
              </div>

              <div className="btn">
                <button onClick={() => redirectOnPage("/how-use-general-science-classroom")}>General Science</button>
              </div>
              <div className="btn">
                <button onClick={() => redirectOnPage("/how-use-chemistry-classroom")}>Chemistry</button>
              </div>
              <div className="btn">
                <button onClick={() => redirectOnPage("/how-use-history-classroom")}>History</button>
              </div>
              <div className="btn">
                <button onClick={() => redirectOnPage("/how-use-mock-geography-classroom")}>Mock Geography</button>
              </div>
              <div className="btn">
                <button onClick={() => redirectOnPage("/how-use-physics-classroom")}>Physics</button>
              </div>
              <div className="btn">
                <button onClick={() => redirectOnPage("/how-use-maths-classroom")}>Maths</button>
              </div>
              <div className="btn">
                <button onClick={() => redirectOnPage("/how-use-english-classroom")}>English</button>
              </div>
            

              <div className="btn">
                <button onClick={() => redirectOnPage("/how-use-current-affairs-classroom")}>Current Affairs</button>
              </div>
              <div className="btn">
                <button onClick={() => redirectOnPage("/how-use-spoken-en-classroom")}>Spoken English</button>
              </div>
              <div className="btn">
                <button onClick={() => redirectOnPage("/how-use-courses")}>Courses</button>
              </div>
              <div className="btn">
                <button onClick={() => redirectOnPage("/how-use-nda-gpt")}>How to use NDA GPT</button>
              </div>
              <div className="btn">
                <button onClick={() => redirectOnPage("/how-use-notes-classroom")}>How to use Notes</button>
              </div>
            </div>
          </div>
        </section>
      </ProfileLayout>
    </GptLayout>
  );
};

export default HowToUse;
